// src/features/fiscalization/mapStatusToVariant.ts
// Maps fiscalization domain status enums to Badge variants.

import type { FiscalReceiptStatus, ShiftStatus, FiscalPointStatus, FiscalProviderStatus } from '@core/types/fiscalization';

export type BadgeVariant = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';

export function mapReceiptStatusToVariant(status: FiscalReceiptStatus | undefined): BadgeVariant {
  switch (status) {
    case 'FISCAL_RECEIPT_STATUS_FISCALIZED':
    case 'FISCAL_RECEIPT_STATUS_DELIVERED':
      return 'success';
    case 'FISCAL_RECEIPT_STATUS_CREATED':
    case 'FISCAL_RECEIPT_STATUS_PENDING':
    case 'FISCAL_RECEIPT_STATUS_RETRY_PENDING':
      return 'warning';
    case 'FISCAL_RECEIPT_STATUS_FAILED':
    case 'FISCAL_RECEIPT_STATUS_PROVIDER_ERROR':
    case 'FISCAL_RECEIPT_STATUS_DELIVERY_FAILED':
      return 'error';
    case 'FISCAL_RECEIPT_STATUS_ABANDONED':
      return 'secondary';
    default:
      return 'secondary';
  }
}

export function mapShiftStatusToVariant(status: ShiftStatus | undefined): BadgeVariant {
  switch (status) {
    case 'SHIFT_STATUS_OPEN':
      return 'success';
    case 'SHIFT_STATUS_CLOSED':
      return 'secondary';
    case 'SHIFT_STATUS_EXPIRED':
      return 'error';
    default:
      return 'secondary';
  }
}

export function mapFiscalPointStatusToVariant(status: FiscalPointStatus | undefined): BadgeVariant {
  switch (status) {
    case 'FISCAL_POINT_STATUS_ACTIVE':
      return 'success';
    case 'FISCAL_POINT_STATUS_REGISTERED':
      return 'warning';
    case 'FISCAL_POINT_STATUS_BLOCKED':
      return 'error';
    case 'FISCAL_POINT_STATUS_DEREGISTERED':
      return 'secondary';
    default:
      return 'secondary';
  }
}

export function mapFiscalProviderStatusToVariant(status: FiscalProviderStatus | undefined): BadgeVariant {
  switch (status) {
    case 'FISCAL_PROVIDER_STATUS_ACTIVE':
      return 'success';
    case 'FISCAL_PROVIDER_STATUS_SUSPENDED':
      return 'warning';
    case 'FISCAL_PROVIDER_STATUS_DECOMMISSIONED':
      return 'error';
    default:
      return 'secondary';
  }
}
